<template>
    <div id="mobilePage">
        <div class="d-flex flex-column rounded align-items-center text-center py-4 bg-white">
            <lazada-banners />
            <br />
            <div class="d-flex flex-column px-lg-5 px-3 align-items-center text-center">
                <img alt="" src="/img/hcpay/hc-icon.svg" class="img-responsive mb-4" style="height:auto;width:2.5rem">
                <span class="font-md font-weight-bold text-capitalize mb-3">{{EnumLabels.ENTER_MOBILE_NUM}}</span>
                <span class="font-s text-secondary">{{EnumLabels.MOBILE_HINT}}</span>
                <info-bar class="mt-4 mb-2">For selected existing Home Credit customers only</info-bar>
            </div>
            <div class="col-lg-8 col-xs-12 d-flex flex-column align-items-center">
                <div class="form-group custom-input-group mt-4">
                    <!-- <span class="input-prefix">+63</span> -->
                    <input type="tel" :value="formattedMobileNumber" @input="mobileInput" @change="mobileInput" pattern="[0-9]" ref="mobileNumber" id="mobileNumberInput" class="form-control custom-input"  :style="invalidAttempt ? 'border-color: #E11931' : ''" :class="{'invalid': $v.mobileNumber.$error, 'valid' : $v.mobileNumber.$dirty && !$v.mobileNumber.$error}" :maxlength="13" placeholder="0XXX XXX XXXX" inputmode="tel">
                    <label class="custom-input-label" for="mobileNumberInput" :style="invalidAttempt ? 'color: #E11931' : ''"  :class="{'invalid': $v.mobileNumber.$error, 'valid' : $v.mobileNumber.$dirty && !$v.mobileNumber.$error}">Mobile Number</label>
                    <img alt="" v-if="$v.mobileNumber.$error" src="/img/hcpay/input-error-icon.svg" class="img-responsive errorIcon mr-1">
                </div>
                <div v-if="$v.mobileNumber.$error || invalidAttempt" class="align-self-start text-start px-3">
                    <div class="invalid-feedback d-inline" v-if="!$v.mobileNumber.required">
                        <span>Mobile Number is required!</span>
                    </div>
                    <div class="invalid-feedback d-inline" v-else-if="!$v.mobileNumber.validMobile">
                        <span>Mobile number format should be 09XX XXX XXXX or 08XX XXX XXXX</span>
                    </div>
                </div>
                <div class="text-left" v-if="showMessage">
                    <div class="flex d-flex justify-content-center message-body">
                        <div class="float-left">
                            <img alt="" src="/img/hcpay/input-error-icon.svg" class="img-responsive">
                        </div>
                        <div class="floaf-right">
                            <span class="text-danger">
                                <small>{{ attempMessage }}</small>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="custom-control custom-checkbox custom-checkbox-green text-left mt-4">
                    <input type="checkbox" class="custom-control-input custom-control-input-green" id="customCheck1" @change="agreeCheck" ref="agree" v-model="checkPrivacyPolicy">
                    <label class="custom-control-label agreement-label text-secondary pl-2" for="customCheck1"><span class="text-danger">*</span>I agree with Home Credit’s <a href="https://homecredit.ph/privacy-policy/" class="text-success font-weight-bold" target="_new">Privacy Notice</a> which governs the processing of my personal information in order to process this transaction</label>
                </div>
                <div class="custom-control custom-checkbox custom-checkbox-green text-left mt-4">
                    <input type="checkbox" class="custom-control-input custom-control-input-green" id="customCheck2" v-model="checkAcceptableUsePolicy">
                    <label class="custom-control-label agreement-label text-secondary pl-2" for="customCheck2">I agree to receive latest deals and updates from Home Credit through mobile app push notifications / e-mail / SMS / and other media platforms.</label>
                </div>
                <pulse-loader :loading="loading" :color="'#C8102E'" :size="'0.5rem'"></pulse-loader>
                <button
                    type="button"
                    id="mobileSubmitBtn"
                    @click="submit"
                    class="btn btn-block rounded-lg font-sm text-capitalize font-weight-bold py-2 mt-3 mb-5"
                    :class="!disabled ? 'btn-secondary text-gray-dk' : 'btn-success'"
                    :disabled="!disabled"
                    modalTrigger
                >submit</button>
                <lazada-return :eventName="'login_click_cancel_go_back'" id="mobileBackToStore">{{EnumLabels.CANCEL_AND_GOBACK_MERCHANT}}</lazada-return>
            </div>
        </div>
        
        <div class="mt-2 d-flex flex-column rounded align-items-center text-center py-4 bg-white">
            <download-opg-v3 class="px-4" google-play-id="loginGooglePlayBtn" qr-code-id="loginQRCode" />
        </div>
    </div>
</template>

<script>
    import { analyticsDirective } from '../../directives/analytics.js';
    import { ERROR } from '../../mixins/error_codes.js';
    import { required } from 'vuelidate/lib/validators'
    import { EnumLabels } from '../../enums/CommonString.js';

    const validMobile = (value) => (/^(09|08)\d{9}$/).test(value);
    export default {
        data(){
            return {
                EnumLabels,
                mobileNumber: "",
                formattedMobileNumber: "",
                mobileNumberClick: false,
                agree: "",
                loading: false,
                noAccount: "HOMECREDIT_ACCOUNT_UNAVAILABLE",
                noPayments: "No available payment options",
                maxAttempt: "You have reached the maximum login attempts. Please try again after 1 hour.",
                checkPrivacyPolicy: false,
                checkAcceptableUsePolicy: false,
                disabled: false,
                showMessage: false,
                attempMessage: "",
                invalidAttempt: false,
            }
        },
        validations: {
            mobileNumber: {
                required,
                validMobile
            },
        },
        computed: {
            formattedPhoneNumber() {
                const cleanedValue = this.mobileNumber.replace(/\s/g, "").replace(/\D/g, "");
                const firstFourDigits = cleanedValue.slice(0, 4);
                const remainingDigits = cleanedValue.slice(4, 7);
                const lastFourDigits = cleanedValue.slice(7);

                let formattedValue = "";
                if (firstFourDigits) {
                    formattedValue += firstFourDigits;
                    if (remainingDigits) {
                    formattedValue += " " + remainingDigits;
                    if (lastFourDigits) {
                        formattedValue += " " + lastFourDigits;
                    }
                    }
                }

                return formattedValue;
            },
        },
        methods:{
            mobileInput(event) {

                let numericOnly = event.target.value.replace(/\D/g, "");

                let formattedNumber = "";
                for(let i = 0 ; i < numericOnly.length; i++){
                    if( i === 4 || i ===7){
                        formattedNumber += " ";
                    }
                    formattedNumber += numericOnly[i];
                }
                numericOnly = numericOnly.slice(0,11);
                this.mobileNumber = numericOnly;

                this.formattedMobileNumber = formattedNumber;

                this.agreeCheck();
            },
            agreeCheck() {
                if(this.checkPrivacyPolicy && this.$v.mobileNumber.validMobile) {
                    this.loading = true;
                    setTimeout(() => {
                        this.loading = false;
                        this.disabled = true;
                    },1500);
                } else {
                    this.loading = true;
                    this.disabled = false;
                    setTimeout(() => {
                        this.loading = false;
                    },1500);
                }

            },
            changeView(view) {
                this.$root.$data.view = view;
            },
            submit() {
                //checking if number field is empty
                if (!this.mobileNumber) {
                    this.invalidAttempt = true;
                } else {

                    var validationPayload = {
                        accountRequest:{
                            os: this.$root.$data.analyticsData.operatingSystem.name+"V"+this.$root.$data.analyticsData.operatingSystem.version,
                            browser: this.$root.$data.analyticsData.browser.name+"V"+this.$root.$data.analyticsData.browser.version,
                            ip: this.$root.transaction.ipAddress,
                            sessionReferenceId: this.$root.$data.transaction.referenceNumber,
                            phone: this.$root.$data.analyticsData.phone,
                            userAgent: this.$root.$data.analyticsData.userAgent,
                        },
                        username : this.mobileNumber.startsWith('0') ? this.mobileNumber.slice(1) : this.mobileNumber,
                        pin : '',
                        checkPrivacyPolicy: this.checkPrivacyPolicy,
                        checkAcceptableUsePolicy: this.checkAcceptableUsePolicy
                    };

                    // show loader
                    this.$dialog.alert('', {
                        view: 'loader',
                        html: true,
                        customClass: 'dialog-sm',
                    });

                    axios
                    .post("lazada-hcpay/user/validation", validationPayload)
                    .catch(({ response }) => {
                        if(response.data.message === "Invalid PIN"){
                            let g4Params = {
                                'userId': this.$root.$data.account.userId,
                                'cuid': this.$root.$data.account.cuid,
                                'ip': this.$root.transaction.ipAddress,
                                'user_agent': this.$root.$data.analyticsData.userAgent,
                                'phone': this.$root.$data.analyticsData.phone,
                                'operating_system': this.$root.$data.analyticsData.operatingSystem.name+"V"+this.$root.$data.analyticsData.operatingSystem.version,
                                'browser': this.$root.$data.analyticsData.browser.name+"V"+this.$root.$data.analyticsData.browser.version,
                                'transaction_type': 'WT',
                                'login_click_privacy_notice': this.checkPrivacyPolicy,
                                'login_click_deals_and_updates': this.checkAcceptableUsePolicy
                            }
                            this.$root.triggerG4Event('login_click_submit',g4Params)

                            this.$root.$data.account.username = this.mobileNumber;
                            this.$root.$data.account.checkPrivacyPolicy = this.checkPrivacyPolicy;
                            this.$root.$data.account.checkAcceptableUsePolicy = this.checkAcceptableUsePolicy;

                            this.changeView("lazada-denomination");
                        } 
                        
                        if(response.data.message === "Account does not exist") {
                            let g4Params = {
                                'userId': this.$root.$data.account.userId,
                                'cuid': this.$root.$data.account.cuid,
                                'ip': this.$root.transaction.ipAddress,
                                'user_agent': this.$root.$data.analyticsData.userAgent,
                                'phone': this.$root.$data.analyticsData.phone,
                                'operating_system': this.$root.$data.analyticsData.operatingSystem.name+"V"+this.$root.$data.analyticsData.operatingSystem.version,
                                'browser': this.$root.$data.analyticsData.browser.name+"V"+this.$root.$data.analyticsData.browser.version,
                                'transaction_type': 'WT',
                                'login_click_privacy_notice': this.checkPrivacyPolicy,
                                'login_click_deals_and_updates': this.checkAcceptableUsePolicy
                            }
                            this.$root.triggerG4Event('leads_gen',g4Params)

                            this.changeView('leads-gen');
                        }
                        
                    }).finally(() => {
                        // hide loader
                        window.dispatchEvent(new CustomEvent("loading", {
                            detail: false
                        }));
                    });
                }
            }
        },
        directives: {
            'analytics' : analyticsDirective
        },
        watch: {
            mobileNumber: {
                handler: function() {
                    this.$v.mobileNumber.$reset();
                    this.loading = true;
                    setTimeout(() => {
                        this.$v.mobileNumber.$touch();
                        this.loading = false;
                        this.showMessage = false;
                        this.invalidAttempt = false;
                    },1500);
                }
            },
        },
        created() {
            this.$root.$data.account.type = 'PHONE';
            this.$root.$data.previousView = 'lazada-mobile';

            let g4Params = {
                'userId': this.$root.$data.account.userId,
                'cuid': this.$root.$data.account.cuid,
                'ip': this.$root.transaction.ipAddress,
                'user_agent': this.$root.$data.analyticsData.userAgent,
                'phone': this.$root.$data.analyticsData.phone,
                'operating_system': this.$root.$data.analyticsData.operatingSystem.name+"V"+this.$root.$data.analyticsData.operatingSystem.version,
                'browser': this.$root.$data.analyticsData.browser.name+"V"+this.$root.$data.analyticsData.browser.version,
                'transaction_type': 'WT',
            }
            this.$root.triggerG4Event('login_page',g4Params)
        }
    }
</script>
<style scoped>
    .errorIcon {
        height: auto;
        width: 1.5rem;
        position: absolute;
        right: 0.5rem;
        bottom: 0.825rem;
    }
    .agreement-label {
        font-size: 12px;
    }
    .attempt-invalid {
        border-color: #E11931;
    }
    .message-body {
        margin: auto;
        width: 100%;
    }
    .float-left {
        float: left;
        width: 10%;
        border: 1px solid transparent;
    }
    .float-right {
        float: right;
        width: 90%;
        border: 1px solid transparent;
    }

    .custom-control-input-green:focus~.custom-control-label::before {
        border-color: #28a745 !important;
        box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25) !important;
    }

    .custom-control-input-green:checked~.custom-control-label::before {
        border-color: #28a745 !important;
        background-color: #28a745 !important;
    }

    .custom-control-input-green:focus:not(:checked)~.custom-control-label::before {
        border-color: #5bd778 !important;
    }

    .custom-control-input-green:not(:disabled):active~.custom-control-label::before {
        background-color: #d6f5dd !important;
        border-color: #d6f5dd !important;
    }
</style>
